module.exports = __webpack_public_path__ + "img/pr-2.6e2b90e9.png";